import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export default function CreateStrategyTrigger({
	children,
}: {
	children: React.ReactNode
}) {
	const { showModal } = useModals()
	const handleCreateAnchorStrategy = () => {
		ampli.anchoringManagementCreateAnchorStrategy()
		showModal('CREATE_ANCHOR_STRATEGY_MODAL')
	}

	return <Slot.Root onClick={handleCreateAnchorStrategy}>{children}</Slot.Root>
}
